var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10C14.7911 10 15.5645 10.2346 16.2223 10.6741C16.8801 11.1136 17.3928 11.7384 17.6955 12.4693C17.9983 13.2002 18.0775 14.0044 17.9231 14.7804C17.7688 15.5563 17.3878 16.269 16.8284 16.8284C16.269 17.3878 15.5563 17.7688 14.7804 17.9231C14.0044 18.0775 13.2002 17.9983 12.4693 17.6955C11.7384 17.3928 11.1136 16.8801 10.6741 16.2223C10.2346 15.5645 10 14.7911 10 14C10.0012 12.9395 10.423 11.9228 11.1729 11.1729C11.9228 10.423 12.9395 10.0012 14 10ZM14 8C12.8133 8 11.6533 8.35189 10.6666 9.01118C9.67988 9.67047 8.91085 10.6075 8.45672 11.7039C8.0026 12.8003 7.88378 14.0067 8.11529 15.1705C8.3468 16.3344 8.91824 17.4035 9.75736 18.2426C10.5965 19.0818 11.6656 19.6532 12.8295 19.8847C13.9933 20.1162 15.1997 19.9974 16.2961 19.5433C17.3925 19.0892 18.3295 18.3201 18.9888 17.3334C19.6481 16.3467 20 15.1867 20 14C20 12.4087 19.3679 10.8826 18.2426 9.75736C17.1174 8.63214 15.5913 8 14 8Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10C14.7911 10 15.5645 10.2346 16.2223 10.6741C16.8801 11.1136 17.3928 11.7384 17.6955 12.4693C17.9983 13.2002 18.0775 14.0044 17.9231 14.7804C17.7688 15.5563 17.3878 16.269 16.8284 16.8284C16.269 17.3878 15.5563 17.7688 14.7804 17.9231C14.0044 18.0775 13.2002 17.9983 12.4693 17.6955C11.7384 17.3928 11.1136 16.8801 10.6741 16.2223C10.2346 15.5645 10 14.7911 10 14C10.0012 12.9395 10.423 11.9228 11.1729 11.1729C11.9228 10.423 12.9395 10.0012 14 10ZM14 8C12.8133 8 11.6533 8.35189 10.6666 9.01118C9.67988 9.67047 8.91085 10.6075 8.45672 11.7039C8.0026 12.8003 7.88378 14.0067 8.11529 15.1705C8.3468 16.3344 8.91824 17.4035 9.75736 18.2426C10.5965 19.0818 11.6656 19.6532 12.8295 19.8847C13.9933 20.1162 15.1997 19.9974 16.2961 19.5433C17.3925 19.0892 18.3295 18.3201 18.9888 17.3334C19.6481 16.3467 20 15.1867 20 14C20 12.4087 19.3679 10.8826 18.2426 9.75736C17.1174 8.63214 15.5913 8 14 8Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80764 3.39355L3.39357 4.80762L6.89941 8.31345L8.31348 6.89938L4.80764 3.39355Z",
    fill: "#424242"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80764 3.39355L3.39357 4.80762L6.89941 8.31345L8.31348 6.89938L4.80764 3.39355Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13H0V15H5V13Z",
    fill: "#424242"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13H0V15H5V13Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8994 19.6865L3.39356 23.1924L4.80764 24.6064L8.31347 21.1006L6.8994 19.6865Z",
    fill: "#424242"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8994 19.6865L3.39356 23.1924L4.80764 24.6064L8.31347 21.1006L6.8994 19.6865Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23H13V28H15V23Z",
    fill: "#424242"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23H13V28H15V23Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1006 19.6865L19.6866 21.1006L23.1924 24.6065L24.6065 23.1924L21.1006 19.6865Z",
    fill: "#424242"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1006 19.6865L19.6866 21.1006L23.1924 24.6065L24.6065 23.1924L21.1006 19.6865Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13H23V15H28V13Z",
    fill: "#424242"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13H23V15H28V13Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1924 3.39356L19.6866 6.89939L21.1006 8.31346L24.6065 4.80763L23.1924 3.39356Z",
    fill: "#424242"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1924 3.39356L19.6866 6.89939L21.1006 8.31346L24.6065 4.80763L23.1924 3.39356Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H13V5H15V0Z",
    fill: "#424242"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H13V5H15V0Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.3a0075fa9bad501994688f0a9ea028ab.svg";
export { ForwardRef as ReactComponent };